import { thunk } from 'easy-peasy';

import api from '~/services/api';
import { IThunkGetIsExpansionPlan } from '../types';

const onGetIsExpansionPlan: IThunkGetIsExpansionPlan = thunk(
  async ({ setIsExpansionPlan }, client) => {
    setIsExpansionPlan(false);
    const { data } = await api.medicaidPlan.getMedicaidPlan(client);
    setIsExpansionPlan(!!data?.medicaidType?.isExpansion);
  },
);

export default onGetIsExpansionPlan;
